import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useModal } from 'hooks/modal.hooks';
import { useGetVcsRepositories } from 'stores/rq/vcs-connections';
import { VcsConnectionsModal } from 'components/organizations/agents/vcs-connections-modal';
import type { VcsApi } from '@env0/vcs-service/api';
import Button from 'components/common/button';
import VcsRepositorySelector from './vcs-repository-selector';
import withLabel from 'components/common/form-controlled/with-label.hoc';

export interface VcsRepositorySelfHostedSelectProps {
  vcsType: VcsApi.VcsType;
  form?: any;
}

const VcsRepositorySelfHostedSelector: React.FC<VcsRepositorySelfHostedSelectProps> = ({ vcsType, form }) => {
  const { data, isFetching } = useGetVcsRepositories(vcsType, 'DeploymentPipeline');
  const {
    hideModal: hideVcsConnectionModal,
    showModal: showVcsConnectionModal,
    isModalOpen: isVcsConnectionModalOpen
  } = useModal();

  return (
    <>
      <VcsRepositorySelector
        form={form}
        data={data}
        loading={isFetching}
        customActions={
          <Button onClick={showVcsConnectionModal} type="primary" size="small">
            <FormattedMessage id="vcs.add-button" />
          </Button>
        }
      />
      {isVcsConnectionModalOpen && (
        <VcsConnectionsModal isModalOpen={true} hideModal={hideVcsConnectionModal} vcsType={vcsType} />
      )}
    </>
  );
};

export default withLabel(VcsRepositorySelfHostedSelector);
